"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 */
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
require("./sis-control-label-settings.component.scss");
var lodash_1 = require("lodash");
var SisControlLabelSettingsComponent = /** @class */ (function () {
    function SisControlLabelSettingsComponent() {
        this.titleModelChange = new core_1.EventEmitter();
        this._isReady = false;
    }
    Object.defineProperty(SisControlLabelSettingsComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    SisControlLabelSettingsComponent.prototype.ngOnInit = function () {
        if (this.titleModel === undefined) {
            this.createEmptyLabel();
            this.titleModel = {
                title_src: 'custom',
                custom_text: this.mapToObj(this.label.toMap())
            };
        }
        else if (this.titleModel.title_src === 'custom') {
            this.label = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder()
                .fromMap(this.objToMap(this.titleModel.custom_text))
                .build();
        }
        else {
            this.createEmptyLabel();
        }
        this._isReady = true;
    };
    SisControlLabelSettingsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.labelInput
            .registerOnChange(function (label) {
            _this.label = label;
            _this.pushTitleModel(_this.titleModel, label);
        });
    };
    SisControlLabelSettingsComponent.prototype.pushTitleModel = function (model, label) {
        var customTitleLength = 0;
        var labelMap = label.toMap();
        this.titleModel.title_src = undefined;
        this.titleModel.custom_text = this.mapToObj(labelMap);
        labelMap.forEach(function (value) { return customTitleLength += lodash_1.isNil(value) ? 0 : value.length; });
        if (customTitleLength > 0) {
            this.titleModel.title_src = 'custom';
        }
        this.titleModelChange.emit(model);
    };
    SisControlLabelSettingsComponent.prototype.createEmptyLabel = function () {
        this.label = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder()
            .withValueForLanguages(this.languages.map(function (language) { return language.getId(); }), '')
            .build();
    };
    SisControlLabelSettingsComponent.prototype.mapToObj = function (map) {
        var obj = {};
        map.forEach(function (v, k) {
            obj[k] = v;
        });
        return obj;
    };
    SisControlLabelSettingsComponent.prototype.objToMap = function (obj) {
        var map = new Map();
        Object.keys(obj).forEach(function (k) {
            map.set(+k, obj[k]);
        });
        return map;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisControlLabelSettingsComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisControlLabelSettingsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisControlLabelSettingsComponent.prototype, "titleModelChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisControlLabelSettingsComponent.prototype, "titleModel", void 0);
    __decorate([
        core_1.ViewChild('labelInput'),
        __metadata("design:type", Object)
    ], SisControlLabelSettingsComponent.prototype, "labelInput", void 0);
    SisControlLabelSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-control-label-settings',
            template: require('./sis-control-label-settings.component.html'),
        })
    ], SisControlLabelSettingsComponent);
    return SisControlLabelSettingsComponent;
}());
exports.SisControlLabelSettingsComponent = SisControlLabelSettingsComponent;
//# sourceMappingURL=sis-control-label-settings.component.js.map